import Splash from "./components/splash";
import Feed from "./components/feed";

import React, {Component} from 'react';

import './App.css';

class App extends Component {

  constructor(props){
    super(props);

    this.state = {
      page:"home"
    }

    this.navigateToPage = this.navigateToPage.bind(this);
  }

  navigateToPage(page){
    this.setState({page});
  }

  render(){
    let content = [];
    switch(this.state.page){
      case "home":
        content.push(<Splash
            navigateToPage = {this.navigateToPage}
          />)
        break;
      case "feed":
        content.push(<Feed />);
        break;
      default:
        content.push(<Splash />)
        break;
    }


    return (
      <div className="App">
        {content}
      </div>
    );

  }
}

export default App;
